import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		text: {
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		section: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
		},
		sectionTitle: {
			fontSize: 16,
			fontWeight: 700,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		// Figma's field: the input is 340 wide, its helper text 8 below and as wide as it needs.
		field: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1),
		},
		input: {
			maxWidth: 340,
		},
		switchLabel: {
			display: "inline-flex",
			alignItems: "center",
			gap: theme.spacing(1),
		},
		terms: {
			margin: 0,
			paddingLeft: theme.spacing(3),
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
			"& li": {
				marginBottom: theme.spacing(1),
			},
			"& li:last-child": {
				marginBottom: 0,
			},
		},
		agree: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1),
		},
		agreeLabel: {
			alignItems: "flex-start",
			marginLeft: 0,
			marginRight: 0,
		},
		checkbox: {
			padding: 0,
			marginRight: theme.spacing(2),
		},
		// Under the label, past the 24px box and its 16px gap.
		agreeError: {
			marginLeft: theme.spacing(5),
		},
	} satisfies Record<string, CSSObject>;
};
